import { render } from "./Gameplay.vue?vue&type=template&id=00928a77&scoped=true"
import script from "./Gameplay.vue?vue&type=script&lang=js"
export * from "./Gameplay.vue?vue&type=script&lang=js"

import "./Gameplay.vue?vue&type=style&index=0&id=00928a77&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00928a77"]])

export default __exports__